<template>
  <div class="divJavaTitle">
    <h1 :style="{ color: titleColor }">
      <img src="../../../../../assets/all/left.png" />{{ title
      }}<slot></slot><img src="../../../../../assets/all/right.png" />
    </h1>
    <p :style="{ color: subTitleColor }" v-if="subTitle">{{ subTitle }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "#000",
    },
    subTitleColor: {
      type: String,
      default: "rgba(109,109,109,1)",
    },
  },
};
</script>
<style>
.div-swiper-teacher .swiper-container .swiper-wrapper .swiper-slide .divImg img{
  width: auto;
  height: 199px;
}
.div-swiper-teacher .swiper-container .swiper-wrapper .swiper-slide .divImg .divDesc{
  height: 250px;
  overflow: hidden;
}
</style>
<style lang="scss" scoped>
.divJavaTitle {
  margin: 0 auto;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  img:first-child {
    width: 90px;
    position: relative;
    top: -15px;
    right: 29px;
  }
  img:last-child {
    width: 130px;
    position: relative;
    top: -15px;
    left: -10px;
  }
  p {
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: 100;
    line-height: 52px;
    position: relative;
    right: 22px;
  }
}
</style>
